/**
 * First we will load all of this project's JavaScript dependencies which
 * includes Vue and other libraries. It is a great starting point when
 * building robust, powerful web applications using Vue and Laravel.
 */

//require('./bootstrap');
import jQuery from 'jquery'
import select2Factory from 'select2'
import DataTable from 'datatables.net-bs5'
import 'datatables.net-bs5/css/dataTables.bootstrap5.css'

window.$ = window.jQuery = jQuery
if (jQuery && jQuery.fn && typeof select2Factory === 'function') {
  select2Factory(window, jQuery)
}
if (jQuery && jQuery.fn && typeof jQuery.fn.dataTable === 'undefined') {
  DataTable(window, jQuery)
}

import './bootstrap';
import '@vuepic/vue-datepicker/dist/main.css';



import moment from 'moment'



import { createApp, defineAsyncComponent, reactive } from 'vue';
import { h } from 'vue';
const app = createApp({});

import { createPinia } from 'pinia'; // vuex alternative
const pinia = createPinia()
import { createRouter, createWebHistory } from 'vue-router';
import { createI18n } from 'vue-i18n';
//DataTables
//window.Vue = require('vue');
//Pagination
import { Bootstrap5Pagination } from 'laravel-vue-pagination';

/*declare class VueZo {
  static install: (app: any, options?: ZoOption) => void;
}*/



//ProgressBar Vue3
import VueProgressBar from "@aacassandra/vue3-progressbar";
const progressbar_options = {
  color: "#bffaf3",
  failedColor: "#874b4b",
  thickness: "10px",
  transition: {
    speed: "0.2s",
    opacity: "0.6s",
    termination: 300,
  },
  autoRevert: true,
  location: "top",
  inverse: false,
};
//



//ProgressBar Vue2
/*import VueProgressBar from 'vue-progressbar'
Vue.use(VueProgressBar, {
    color: 'rgb(143, 255, 199)',
    failedColor: 'red', 
    height: '5px',
    thickness: '5px',
  })*/
//

/*Vue.filter('formatDate', function(value) {
  if (value) {
    return moment(String(value)).format('DD.MM.YYYY')
  }
})*/

// Force default LIGHT theme (Metronic / Bootstrap theme-mode)
try {
  // dacă vrei să fie mereu light pentru toți:
  localStorage.setItem('kt_theme_mode', 'light');
  localStorage.setItem('data-bs-theme', 'light');

  document.documentElement.setAttribute('data-bs-theme', 'light');
  document.documentElement.setAttribute('data-theme', 'light');
} catch (e) { }

app.config.globalProperties.$filters = {
  formatDate(value) {
    if (value) {
      return moment(String(value)).format('DD.MM.YYYY')
    }
  },
  short_hand(nume) {
    // You can put your logic here...
    let words = nume.split(" ")
    let short_hand = words[0][0] + words[words.length - 1][0]
    return short_hand // <-- The return value as Per logic
  },
  initialeFirma(nume) {
    if (!nume) return "";
    const exclude = ['SC', 'S.C.', 'SRL', 'S.R.L.', 'SA', 'S.A.', 'SRLD'];
    return nume
      .split(' ')
      .filter(w => !exclude.includes(w.toUpperCase()))
      .map(w => w[0])
      .join('')
      .toUpperCase();
  },
  toCurrency(value) {
    if (value) {
      var formatter = new Intl.NumberFormat('ro-RO', {
        style: 'currency',
        currency: 'RON',
        currencyDisplay: 'symbol',
      });
      return formatter.format(value);
    }
  }
}



// <p>{{ $filters.currencyUSD(accountBalance) }}</p> - de folosit syntaxa 

import Form from 'vform'
import {
  //Button,
  HasError,
  AlertError,
  //AlertErrors,
  //AlertSuccess
} from 'vform/src/components/bootstrap5'
window.Form = Form;

//Emitter 
import emitter from "./Plugins/mitt";
window.emitter = emitter;
//emitter.emit('AfterCreate')



import Select2 from 'vue3-select2-component';

//Alerte
import VueSweetalert2 from 'vue-sweetalert2';
import 'sweetalert2/dist/sweetalert2.min.css';


import swal from 'sweetalert2'
window.swal = swal;

app.directive('focus', {
  mounted(el) {
    el.focus()
  }
})

// Directive to navigate form inputs on ENTER and ARROW (Up, Down, Left, Right) keys
app.directive('enter-next', {
  mounted(el) {
    el._formNavHandler = function(e) {
      const keys = ['Enter', 'ArrowRight', 'ArrowLeft', 'ArrowUp', 'ArrowDown'];
      if (!keys.includes(e.key) || e.shiftKey || e.ctrlKey || e.altKey) return;

      const target = e.target;
      if (!target) return;
      const tagName = target.tagName.toLowerCase();
      
      // Do not intercept Enter inside textareas or submit buttons
      if (e.key === 'Enter') {
        if (tagName === 'textarea') return;
        if (target.type === 'submit') return;
      }

      // Check if target is inside a multiselect
      const multiselectEl = target.closest('.multiselect');
      if (multiselectEl) {
        // If multiselect dropdown menu is open and user presses ArrowUp or ArrowDown, let native Vue-Multiselect handle highlight
        const dropdownMenu = multiselectEl.querySelector('.multiselect__content-wrapper');
        const isOpen = dropdownMenu && dropdownMenu.style.display !== 'none' && multiselectEl.classList.contains('multiselect--active');
        if (isOpen && ['ArrowUp', 'ArrowDown'].includes(e.key)) {
          return; // Allow highlighting options from dropdown
        }
      }

      // If user is inside a text input and presses Left/Right, don't hijack cursor position unless at boundary
      if (tagName === 'input' && ['text', 'search', 'number', 'email', 'tel', 'url'].includes(target.type) && ['ArrowLeft', 'ArrowRight'].includes(e.key)) {
        if (typeof target.selectionStart === 'number') {
          const valLen = target.value ? target.value.length : 0;
          if (e.key === 'ArrowLeft' && target.selectionStart > 0) return;
          if (e.key === 'ArrowRight' && target.selectionEnd < valLen) return;
        }
      }

      const container = target.closest('form, .card-body, .modal-content, table, .border, .content') || document.body;
      if (!container) return;

      // Select actual focusable element targets (including input inside multiselect or the multiselect itself)
      const selector = 'input:not([type="hidden"]):not([disabled]):not([readonly]), select:not([disabled]), textarea:not([disabled]), button[type="submit"]';
      const rawElements = Array.from(container.querySelectorAll(selector)).filter(item => {
        return item.offsetWidth > 0 || item.offsetHeight > 0 || item.getClientRects().length > 0;
      });

      // Filter out duplicate inputs within the same multiselect container if any
      const focusables = [];
      rawElements.forEach(item => {
        const ms = item.closest('.multiselect');
        if (ms) {
          if (!focusables.includes(item)) {
            focusables.push(item);
          }
        } else {
          focusables.push(item);
        }
      });

      const currentIdx = focusables.findIndex(item => item === target || item.contains(target) || (target.closest('.multiselect') && item.closest('.multiselect') === target.closest('.multiselect')));
      if (currentIdx === -1) return;

      let nextEl = null;

      if (e.key === 'Enter' || e.key === 'ArrowRight') {
        if (currentIdx < focusables.length - 1) {
          nextEl = focusables[currentIdx + 1];
        }
      } else if (e.key === 'ArrowLeft') {
        if (currentIdx > 0) {
          nextEl = focusables[currentIdx - 1];
        }
      } else if (e.key === 'ArrowUp' || e.key === 'ArrowDown') {
        // Table or Grid Row vertical navigation
        const tr = target.closest('tr, .row');
        if (tr && tr.parentElement) {
          const rows = Array.from(tr.parentElement.querySelectorAll('tr, .row')).filter(r => r.querySelector(selector));
          const rowIdx = rows.indexOf(tr);
          if (rowIdx !== -1) {
            const rowInputs = Array.from(tr.querySelectorAll(selector));
            const colIdx = rowInputs.findIndex(item => item === target || item.contains(target) || (target.closest('.multiselect') && item.closest('.multiselect') === target.closest('.multiselect')));

            if (e.key === 'ArrowDown' && rowIdx < rows.length - 1) {
              const nextRowInputs = Array.from(rows[rowIdx + 1].querySelectorAll(selector));
              nextEl = nextRowInputs[colIdx] || nextRowInputs[nextRowInputs.length - 1];
            } else if (e.key === 'ArrowUp' && rowIdx > 0) {
              const prevRowInputs = Array.from(rows[rowIdx - 1].querySelectorAll(selector));
              nextEl = prevRowInputs[colIdx] || prevRowInputs[prevRowInputs.length - 1];
            }
          }
        }
      }

      if (nextEl) {
        // If selecting multiselect option with Enter, delay slightly so Vue-Multiselect updates its value before focus moves
        if (multiselectEl && e.key === 'Enter') {
          setTimeout(() => {
            const innerInput = nextEl.classList.contains('multiselect') ? nextEl.querySelector('input') : (nextEl.closest('.multiselect') ? nextEl.closest('.multiselect').querySelector('input') || nextEl : nextEl);
            const focusTarget = innerInput || nextEl;
            focusTarget.focus();
            if (typeof focusTarget.select === 'function' && focusTarget.type !== 'date') {
              try { focusTarget.select(); } catch (err) {}
            }
          }, 50);
          return;
        }

        e.preventDefault();
        e.stopPropagation();

        // Focus the next element or the input inside multiselect
        const innerInput = nextEl.classList.contains('multiselect') ? nextEl.querySelector('input') : (nextEl.closest('.multiselect') ? nextEl.closest('.multiselect').querySelector('input') || nextEl : nextEl);
        const focusTarget = innerInput || nextEl;
        
        focusTarget.focus();
        if (typeof focusTarget.select === 'function' && focusTarget.type !== 'date') {
          try {
            focusTarget.select();
          } catch (err) {}
        }
      }
    };
    el.addEventListener('keydown', el._formNavHandler, true);
  },
  unmounted(el) {
    if (el._formNavHandler) {
      el.removeEventListener('keydown', el._formNavHandler, true);
    }
  }
})


const toast = swal.mixin({
  toast: true,
  position: 'top-end',
  showConfirmButton: false,
  timer: 3000
});
window.toast = toast;

//window.Updateds = new Vue();
//window.Fire =  new Vue();

//Barcode
//import VueBarcode from 'vue-barcode';
//Vue.use(VueBarcode);
//Vue.component('VueBarcode', require('vue-barcode'));

//infinite-loader

//Vue.component('InfiniteLoading', require('vue-infinite-loading'));
//Pagination
//Vue.component('pagination', require('laravel-vue-pagination'));
//

//Vue Infinite Loading
import InfiniteLoading from "v3-infinite-loading";


import VueEditor from "vue3-editor";


/*import InfiniteLoading from 'vue-infinite-loading';
Vue.use(InfiniteLoading, {
  props: {
    spinner: 'waveDots',
    //distance: '1',
    forceUseInfiniteWrapper: 'true',
  },
  system: {
    //throttleLimit: 50,
  },
});*/

//import Vue from 'vue';


import en from './components/Locales/en-EN.json';
import ro from './components/Locales/ro-RO.json';

const messages = {
  "Romana": ro,
  "English": en,
};

let limba_app;

if (!localStorage.language) {
  limba_app = "Romana";
}
else if (localStorage.language) {
  limba_app = localStorage.language
}

const i18n = createI18n({
  locale: limba_app,
  messages
})

/*Vue.component(
  'notificari',
  require('./components/Module/Notificari.vue').default
);*/

// Pinia 
import { useUserStore } from './stores/user';


//Componente 
import profil_dropdown from './components/Module/UserPanelDropDown.vue';
import ModalSchimbaFirme from './components/Module/ModalSchimbaFirma.vue';
import WorkSidebarMenu from './components/Administrare/work_components/WorkSidebarMenu.vue';
import ModalSelecteazaFirmaLucru from './components/Administrare/work_components/ModalSelecteazaFirmaLucru.vue';
import SidebarModeSwitcher from './components/Administrare/work_components/SidebarModeSwitcher.vue';
import ClientSidebarMenu from './components/Administrare/work_components/ClientSidebarMenu.vue';
import AppHeaderFirmWidget from './components/Module/AppHeaderFirmWidget.vue';
//

//Componente Router
const Home_vue = () => import('./components/General/Home.vue');
const Conturi_vue = () => import('./components/Conturi/Clienti.vue');
const SetariCont_vue = () => import('./components/Conturi/SetariCont.vue');

const Facturare_AdaugaFactura_vue = () => import('./components/Facturare/Iesiri/Facturi/AdaugaFactura.vue');
const ListaFacturiEmise_vue = () => import('./components/Facturare/Iesiri/Facturi/ListaFacturiEmise.vue');

const FactProforma_AdaugaFacturaProforma_vue = () => import('./components/Facturare/Iesiri/FacturaProforma/AdaugaFacturaProforma.vue');
const FactProforma_ListaFacturiProformeEmise_vue = () => import('./components/Facturare/Iesiri/FacturaProforma/ListaFacturiProformeEmise.vue');

const ListaFacturi_vue = () => import('./components/Facturare/Intrari/ListaFacturi.vue');

const FirmeleMele_vue = () => import('./components/Conturi/FirmeleMele.vue');

const Incarcari_vue = () => import('./components/Acte/Incarcari.vue');

const PlanConturi_vue = () => import('./components/Contabilitate/PlanConturi.vue');

const RegistruJurnal_vue = () => import('./components/Contabilitate/RegistruJurnal.vue');
const RegistruIncasariPlati_vue = () => import('./components/Contabilitate/RegistruIncasariPlati.vue');

//Administrare
const Adm_Utilizatori_vue = () => import('./components/Administrare/Utilizatori.vue');
const Adm_Firme_vue = () => import('./components/Administrare/Firme.vue');
const Adm_Abonamente_vue = () => import('./components/Administrare/Abonamente.vue');
const Adm_Work_vue = () => import('./components/Administrare/Work.vue');

const NotFound = () => import('./components/General/NotFound.vue');
//import footer from './components/General/Footer.vue'





//


const routes = [
  //Administrare
  { path: '/', component: Home_vue },
  { path: '/facturare/iesiri', component: Facturare_AdaugaFactura_vue },
  { path: '/facturare', component: ListaFacturiEmise_vue },

  { path: '/facturare/fp/nou', component: FactProforma_AdaugaFacturaProforma_vue },
  { path: '/facturare/fp', component: FactProforma_ListaFacturiProformeEmise_vue },

  { path: '/intrari/facturi', component: ListaFacturi_vue },

  { path: '/incarcari', component: Incarcari_vue },

  { path: '/firmele-mele', component: FirmeleMele_vue },
  { path: '/contul-meu', component: SetariCont_vue },

  { path: '/plan-conturi', component: PlanConturi_vue },
  { path: '/registru-jurnal', component: RegistruJurnal_vue },
  { path: '/registru-incasari-plati', component: RegistruIncasariPlati_vue },

  { path: '/conturi', component: Conturi_vue },

  //Administrare
  { path: '/administrare/utilizatori', component: Adm_Utilizatori_vue },
  { path: '/administrare/firme', component: Adm_Firme_vue },
  { path: '/administrare/abonamente', component: Adm_Abonamente_vue },
  { path: '/administrare/work/:firmaId?/:module?/:submodule?', component: Adm_Work_vue },
  //
  { path: '/:pathMatch(.*)*', name: 'not-found', component: NotFound }
]



const Router = createRouter({
  history: createWebHistory(),
  scrollBehavior: (to, from, savedPosition) => ({
    top: 0,
    left: 0,
    behavior: 'smooth'
  }),
  linkExactActiveClass: "active",
  linkActiveClass: "active",
  routes,
})

let meLoaded = false;
Router.beforeEach(async (to, from, next) => {
  if (!meLoaded) {
    const userStore = useUserStore(pinia);
    if (window.initialUserData && window.initialUserData.id) {
      userStore.user = window.initialUserData;
      userStore.firmaCurenta = window.initialUserData.firma_curenta ?? null;
      userStore.loaded = true;
    } else {
      try {
        await userStore.fetchMe();
      } catch {
        userStore.hydrateFromMeta();
      }
    }

    const user = userStore.user ?? null;
    const tipCont = user?.tip_cont ?? null;

    // poate fi obiect, id simplu sau null pentru user nou
    let firmaCurentaRaw = user?.firma_curenta ?? userStore.firmaCurenta ?? null;

    // normalizăm valori „goale”
    if (firmaCurentaRaw === '' || firmaCurentaRaw === 0) {
      firmaCurentaRaw = null;
    }

    let firmaId = null;
    let stareFirma = null;
    let tipEntitate = null;
    let tipContabilitate = null;

    if (firmaCurentaRaw && typeof firmaCurentaRaw === 'object') {
      firmaId = firmaCurentaRaw.id ?? null;
      stareFirma = firmaCurentaRaw.stare_firma ?? null;
      tipEntitate = firmaCurentaRaw.tip_entitate ?? null;
      tipContabilitate = firmaCurentaRaw.tip_contabilitate ?? null;
    } else if (firmaCurentaRaw) {
      // e deja ID-ul firmei
      firmaId = firmaCurentaRaw;
    }

    gateState.tip_cont = tipCont;
    gateState.firma_curenta = firmaCurentaRaw;
    gateState.stare_firma = stareFirma;
    gateState.tip_entitate = tipEntitate;
    gateState.tip_contabilitate = tipContabilitate;
    app.config.globalProperties.uid = user?.id ?? null;
    meLoaded = true;
  }
  next();
});

//gates
import Gate from "./Gate";

const initFc = window.initialUserData?.firma_curenta ?? null;
let initTipEnt = initFc?.tip_entitate ?? null;
let initTipContab = initFc?.tip_contabilitate ?? null;
let initTipCont = window.initialUserData?.tip_cont ?? null;

if (initFc) {
  const dUpper = (initFc.denumire || '').toUpperCase();
  if (initTipEnt === 'PFA' || dUpper.includes('ÎNTREPRINDERE INDIVIDUALĂ') || dUpper.includes('INTREPRINDERE INDIVIDUALA') || dUpper.includes(' I.I.') || dUpper.includes(' PFA') || dUpper.includes(' I.F.') || dUpper.includes(' C.M.I.') || dUpper.includes(' P.F.A.')) {
    initTipContab = 'SIMPLIFICATA';
    initTipEnt = 'PFA';
  }
}

const gateState = reactive(new Gate(initTipCont, initFc?.id ?? null, initFc?.stare_firma ?? null, initTipEnt, initTipContab));
gateState.firma_curenta = initFc;
app.config.globalProperties.$gate = gateState;
window.$gate = gateState;
app.config.globalProperties.uid = window.initialUserData?.id ?? null;


//Setare limba default pt aplicatie 

//i18n.locale = localStorage.language;
i18n.global.locale = localStorage.language || 'Romana';

// Keenthemes core & layout (ordered side‑effect imports; they attach to window)
// Core utilities first
import '../tema/src/js/components/util.js'
// Ensure KTUtil exists and provide helpers if missing (without mutating frozen object)
(() => {
  if (!window.KTUtil) window.KTUtil = {}
  const utilRef = window.KTUtil
  const needsOnDom = typeof utilRef.onDOMContentLoaded !== 'function'
  const needsVisible = typeof utilRef.isVisibleInContainer !== 'function'
  if (needsOnDom || needsVisible) {
    const proxy = Object.create(utilRef)
    if (needsOnDom) {
      Object.defineProperty(proxy, 'onDOMContentLoaded', {
        value: (cb) => {
          if (document.readyState === 'loading') {
            document.addEventListener('DOMContentLoaded', cb)
          } else {
            // Defer to next tick so other modules (KTToggle/KTMenu/etc.) finish attaching
            setTimeout(() => { try { cb() } catch (e) { console.warn('KTUtil onDOMContentLoaded cb error:', e) } }, 0)
          }
        },
        writable: true,
        configurable: true,
        enumerable: true,
      })
    }
    if (needsVisible) {
      Object.defineProperty(proxy, 'isVisibleInContainer', {
        value: (el, container) => {
          if (!el) return false
          const style = window.getComputedStyle(el)
          if (style.display === 'none' || style.visibility === 'hidden' || Number(style.opacity) === 0) return false
          const r = el.getBoundingClientRect()
          const c = container && container.getBoundingClientRect ? container.getBoundingClientRect() : null
          const inView = (rect, cont) => (
            rect.bottom > (cont?.top ?? 0) &&
            rect.top < (cont?.bottom ?? window.innerHeight) &&
            rect.right > (cont?.left ?? 0) &&
            rect.left < (cont?.right ?? window.innerWidth)
          )
          return inView(r, c)
        },
        writable: true,
        configurable: true,
        enumerable: true,
      })
    }
    window.KTUtil = proxy
  }
})()

import '../tema/src/js/components/event-handler.js'
if (!window.KTEventHandler || typeof window.KTEventHandler.on !== 'function' || typeof window.KTEventHandler.trigger !== 'function') {
  const listeners = new Map()
  window.KTEventHandler = {
    on: (name, fn) => {
      if (!listeners.has(name)) listeners.set(name, new Set())
      listeners.get(name).add(fn)
    },
    off: (name, fn) => {
      if (!listeners.has(name)) return
      if (fn) listeners.get(name).delete(fn)
      else listeners.get(name).clear()
    },
    trigger: (name, target, ...args) => {
      const set = listeners.get(name)
      if (!set) return
      for (const fn of set) {
        try { fn(target, ...args) } catch (e) { console.warn('KTEventHandler listener error:', e) }
      }
    },
  }
}

import '../tema/src/js/components/app.js'
if (!window.KTApp) window.KTApp = {}
if (typeof window.KTApp.init !== 'function') {
  window.KTApp.init = () => { }
}
import '../tema/src/js/components/cookie.js'
import '../tema/src/js/components/blockui.js'
import '../tema/src/js/components/dialer.js'
// Ensure KTDialer exists for _init.js (provide minimal API)
if (!window.KTDialer) {
  const shim = function () { }
  shim.init = shim.init || (() => { })
  shim.createInstances = shim.createInstances || (() => { })
  shim.getInstance = shim.getInstance || (() => null)
  window.KTDialer = shim
}
import * as KTDrawerMod from '../tema/src/js/components/drawer.js'
if (!window.KTDrawer) {
  const realDrawer = KTDrawerMod.KTDrawer || KTDrawerMod.default || KTDrawerMod
  if (realDrawer) {
    window.KTDrawer = realDrawer
  }
}
if (!window.KTDrawer) {
  const shim = function () { }
  shim.getInstance = () => null
  shim.createInstances = () => { }
  shim.hideAll = () => { }
  shim.init = () => { }
  window.KTDrawer = shim
}
// Ensure KTDrawer.init exists without mutating a frozen object
(() => {
  const base = window.KTDrawer
  if (typeof base?.init === 'function') return

  const wrapper = function (...args) {
    if (typeof base === 'function') return base.apply(this, args)
  }
  try { Object.setPrototypeOf(wrapper, base) } catch { }
  try { Object.assign(wrapper, base) } catch { }

  Object.defineProperty(wrapper, 'init', { value: () => { }, configurable: true })
  window.KTDrawer = wrapper
})()
import '../tema/src/js/components/feedback.js'
import '../tema/src/js/components/image-input.js'
// Ensure KTImageInput exists for _init.js (provide minimal API)
if (!window.KTImageInput) {
  const shim = function () { }
  shim.init = shim.init || (() => { })
  shim.createInstances = shim.createInstances || (() => { })
  shim.getInstance = shim.getInstance || (() => null)
  window.KTImageInput = shim
}
import * as KTMenuMod from '../tema/src/js/components/menu.js'
// Prefer real export, then fallback to shim
if (!window.KTMenu) {
  const realMenu = KTMenuMod.KTMenu || KTMenuMod.default || KTMenuMod
  if (realMenu) {
    window.KTMenu = realMenu
  }
}
if (!window.KTMenu) {
  const shim = function () { }
  shim.getInstance = () => null
  shim.createInstances = () => { }
  shim.init = () => { }
  window.KTMenu = shim
}
// Ensure KTMenu exposes required statics without mutating a frozen object
(() => {
  const base = window.KTMenu
  const needs = !base ||
    typeof base.getInstance !== 'function' ||
    typeof base.createInstances !== 'function' ||
    typeof base.init !== 'function'
  if (!needs) return
  const wrapper = function (...args) {
    if (typeof base === 'function') return base.apply(this, args)
  }
  try { Object.setPrototypeOf(wrapper, base) } catch { }
  try { Object.assign(wrapper, base) } catch { }
  if (typeof wrapper.getInstance !== 'function') {
    Object.defineProperty(wrapper, 'getInstance', { value: () => null, configurable: true })
  }
  if (typeof wrapper.createInstances !== 'function') {
    Object.defineProperty(wrapper, 'createInstances', { value: () => { }, configurable: true })
  }
  if (typeof wrapper.init !== 'function') {
    Object.defineProperty(wrapper, 'init', { value: () => { }, configurable: true })
  }
  window.KTMenu = wrapper
})()
import '../tema/src/js/components/password-meter.js'
// Ensure KTPasswordMeter exists for _init.js (provide minimal API)
if (!window.KTPasswordMeter) {
  const shim = function () { }
  shim.init = shim.init || (() => { })
  shim.createInstances = shim.createInstances || (() => { })
  shim.getInstance = shim.getInstance || (() => null)
  window.KTPasswordMeter = shim
}
import '../tema/src/js/components/scroll.js'
// Ensure KTScroll exists for _init.js (provide minimal API)
if (!window.KTScroll) {
  const shim = function () { }
  shim.init = shim.init || (() => { })
  shim.update = shim.update || (() => { })
  shim.createInstances = shim.createInstances || (() => { })
  shim.getInstance = shim.getInstance || (() => null)
  window.KTScroll = shim
}
import '../tema/src/js/components/scrolltop.js'
// Ensure KTScrolltop exists for _init.js (provide minimal API)
if (!window.KTScrolltop) {
  const shim = function () { }
  shim.init = shim.init || (() => { })
  shim.createInstances = shim.createInstances || (() => { })
  shim.getInstance = shim.getInstance || (() => null)
  window.KTScrolltop = shim
}
import '../tema/src/js/components/search.js'
import '../tema/src/js/components/stepper.js'
import '../tema/src/js/components/sticky.js'
// Ensure KTSticky exists for _init.js (provide minimal API)
if (!window.KTSticky) {
  const shim = function () { }
  shim.init = shim.init || (() => { })
  shim.update = shim.update || (() => { })
  shim.createInstances = shim.createInstances || (() => { })
  shim.getInstance = shim.getInstance || (() => null)
  window.KTSticky = shim
}
import '../tema/src/js/components/swapper.js'
// Ensure KTSwapper exists for _init.js (provide minimal API)
if (!window.KTSwapper) {
  const shim = function () { }
  shim.init = shim.init || (() => { })
  shim.update = shim.update || (() => { })
  shim.createInstances = shim.createInstances || (() => { })
  shim.getInstance = shim.getInstance || (() => null)
  window.KTSwapper = shim
}
import * as KTToggleMod from '../tema/src/js/components/toggle.js'
if (!window.KTToggle) {
  window.KTToggle = function () { }
}
// Ensure required KTToggle statics exist without mutating a frozen object
(() => {
  const base = window.KTToggle
  const missing =
    typeof base.init !== 'function' ||
    typeof base.createInstances !== 'function' ||
    typeof base.getInstance !== 'function'
  if (!missing) return

  // wrapper care deleagă către implementarea existentă (dacă e funcție)
  const wrapper = function (...args) {
    if (typeof base === 'function') return base.apply(this, args)
  }
  try { Object.setPrototypeOf(wrapper, base) } catch { }
  try { Object.assign(wrapper, base) } catch { }

  if (typeof wrapper.init !== 'function') {
    Object.defineProperty(wrapper, 'init', { value: () => { }, configurable: true })
  }
  if (typeof wrapper.createInstances !== 'function') {
    Object.defineProperty(wrapper, 'createInstances', { value: () => { }, configurable: true })
  }
  if (typeof wrapper.getInstance !== 'function') {
    Object.defineProperty(wrapper, 'getInstance', { value: () => null, configurable: true })
  }

  window.KTToggle = wrapper
})()

  // Load layout scripts *after* KTUtil/KTEventHandler/KTApp are attached
  ; (async () => {
    try {
      await import('../tema/src/js/layout/sidebar.js')
      await import('../tema/src/js/layout/search.js')
      await import('../tema/src/js/layout/toolbar.js')
      await import('../tema/src/js/layout/theme-mode.js')
      if (!window.KTThemeMode) {
        window.KTThemeMode = (function () {
          const listeners = new Map()
          return {
            on: (name, fn) => {
              if (!listeners.has(name)) listeners.set(name, new Set())
              listeners.get(name).add(fn)
            },
            off: (name, fn) => {
              if (!listeners.has(name)) return
              if (fn) listeners.get(name).delete(fn)
              else listeners.get(name).clear()
            },
            trigger: (name, target, ...args) => {
              const set = listeners.get(name)
              if (!set) return
              for (const fn of set) {
                try { fn(target, ...args) } catch (e) { console.warn('KTThemeMode listener error:', e) }
              }
            },
          }
        })()
      }
      await import('../tema/src/js/layout/theme-mode-user.js')
      // Finally initialize components (expects KTApp/KTUtil to exist)
      await import('../tema/src/js/components/_init.js')
    } catch (e) {
      console.warn('KT layout load failed:', e)
    }
  })()
// After layout bootstraps, initialize menus; add a manual fallback for header user menu if needed
setTimeout(() => {
  try {
    const fallbackInitHeaderMenu = () => {
      const wrap = document.getElementById('kt_header_user_menu_toggle')
      if (!wrap) return
      const trigger = wrap.querySelector('[data-kt-menu-trigger]')
      const menuEl = wrap.querySelector('.menu[data-kt-menu="true"]')
      if (!trigger || !menuEl) return

      // if KTMenu has a working instance, skip fallback
      try {
        const hasReal = window.KTMenu && (typeof window.KTMenu.getInstance === 'function' ? window.KTMenu.getInstance(menuEl) : null)
        if (hasReal) return
      } catch (_) { }

      // Minimal dropdown behavior: hover on lg+, click on < lg
      wrap.style.position = wrap.style.position || 'relative'
      menuEl.style.position = 'absolute'
      menuEl.style.minWidth = menuEl.style.minWidth || '250px'
      const place = () => {
        // bottom-end of wrap
        const h = trigger.offsetHeight || 0
        menuEl.style.top = (h + 6) + 'px'
        menuEl.style.right = '0'
        menuEl.style.left = 'auto'
        menuEl.style.zIndex = '1050'
      }
      const show = () => {
        place()
        menuEl.classList.add('show')
        menuEl.style.display = 'block'
        document.addEventListener('click', onDocClick, { once: true })
      }
      const hide = () => {
        menuEl.classList.remove('show')
        menuEl.style.display = 'none'
      }
      const toggle = (e) => { e && e.preventDefault(); (menuEl.classList.contains('show') ? hide() : show()) }
      const onDocClick = (e) => { if (!wrap.contains(e.target)) hide() }

      // Initialize nested submenus inside the user dropdown (e.g., Culoare tema)
      const initSubmenus = () => {
        const triggers = menuEl.querySelectorAll('[data-kt-menu-trigger]')
        triggers.forEach((t) => {
          // skip the outermost trigger
          if (t === trigger) return
          // Find the closest menu-item root to anchor positioning
          const item = t.closest('.menu-item') || t.parentElement
          const sub = item ? item.querySelector(':scope > .menu[data-kt-menu="true"]') : null
          if (!sub) return

          // cleanup existing listeners by cloning
          const newT = t.cloneNode(true)
          t.parentNode.replaceChild(newT, t)

          // Basic placement for left-start (as in data-kt-menu-placement="left-start")
          sub.style.position = 'absolute'
          sub.style.minWidth = sub.style.minWidth || '150px'
          const placeSub = () => {
            const itRect = item.getBoundingClientRect()
            const wrapRect = wrap.getBoundingClientRect()
            const offsetTop = itRect.top - wrapRect.top
            sub.style.top = offsetTop + 'px'
            // open to the left of the main dropdown
            const w = menuEl.offsetWidth || 200
            sub.style.right = (w + 8) + 'px'
            sub.style.left = 'auto'
            sub.style.zIndex = '1051'
          }
          const showSub = () => { placeSub(); sub.classList.add('show'); sub.style.display = 'block' }
          const hideSub = () => { sub.classList.remove('show'); sub.style.display = 'none' }
          const toggleSub = (e) => { e && e.preventDefault(); (sub.classList.contains('show') ? hideSub() : showSub()) }

          const mq2 = window.matchMedia('(min-width: 992px)')
          const bindSub = () => {
            if (mq2.matches) {
              newT.addEventListener('mouseenter', showSub)
              item.addEventListener('mouseleave', hideSub)
            } else {
              newT.addEventListener('click', toggleSub)
            }
          }
          bindSub()
          mq2.addEventListener ? mq2.addEventListener('change', () => { hideSub(); bindSub() }) : null
        })
      }

      // Clear previous listeners by cloning (simple and safe)
      const newTrigger = trigger.cloneNode(true)
      trigger.parentNode.replaceChild(newTrigger, trigger)

      const mq = window.matchMedia('(min-width: 992px)')
      const bind = () => {
        if (mq.matches) {
          newTrigger.addEventListener('mouseenter', show)
          wrap.addEventListener('mouseleave', hide)
        } else {
          newTrigger.addEventListener('click', toggle)
        }
      }
      bind()
      initSubmenus()
      mq.addEventListener ? mq.addEventListener('change', () => { hide(); /* rebind */ fallbackInitHeaderMenu() }) : null
    }

    // Try real KTMenu init first
    if (window.KTMenu) {
      if (typeof window.KTMenu.init === 'function') {
        window.KTMenu.init()
      } else if (typeof window.KTMenu.createInstances === 'function') {
        window.KTMenu.createInstances()
      }
    }

    // Always ensure header menu works, even if KTMenu is inert
    fallbackInitHeaderMenu()
  } catch (e) {
    console.warn('KTMenu init/fallback failed:', e)
  }
}, 0)


/**
 * Next, we will create a fresh Vue application instance and attach it to
 * the page. Then, you may begin adding components to this application
 * or customize the JavaScript scaffolding to fit your unique needs.
 */

/*const app = createApp(App)({
  components: {
    profil_dropdown
  }
})*/



app.use(Router);
app.use(i18n);
app.use(VueSweetalert2);
//app.use(VueGates);
app.use(pinia);
app.use(VueEditor);
app.use(VueProgressBar, progressbar_options)
app.config.globalProperties.emitter = emitter;
//app.config.globalProperties.gate = new Gate(window.user);
app.component('profil_dropdown', profil_dropdown)
//app.component('site_footer', footer)
app.component('ModalSchimbaFirme', ModalSchimbaFirme);
app.component('WorkSidebarMenu', WorkSidebarMenu);
app.component('ModalSelecteazaFirmaLucru', ModalSelecteazaFirmaLucru);
app.component('SidebarModeSwitcher', SidebarModeSwitcher);
app.component('ClientSidebarMenu', ClientSidebarMenu);
app.component('AppHeaderFirmWidget', AppHeaderFirmWidget);
app.component('Select2', Select2)
app.component(HasError.name, HasError)
app.component(AlertError.name, AlertError)
app.component("infinite-loading", InfiniteLoading);
app.component('pagination', Bootstrap5Pagination)
app.component('ListaFacturiEmise', ListaFacturiEmise_vue)
app.component('AdaugaFactura', defineAsyncComponent(Facturare_AdaugaFactura_vue))
//app.use(Bootstrap5Pagination);
app.mount('#app')


/*const app = createApp()({
    el: '#app',
    router,
    i18n,
    data:{
      search: ''
    },
    methods:{

          cautare: _.debounce(() => {
            Fire.$emit('searching');
          },1000),

          printme() {
            window.print(); 
          },
          
          
        }
    
});*/
